import { Component, namespace, State, Vue } from 'nuxt-property-decorator'
import { Experience } from '~/types/experience'

const experience = namespace('experience')

@Component
export default class ExperienceBreadcrumb extends Vue {
  @experience.State breadcrumb!: Experience.Breadcrumb
  @State klook!: Data.Klook

  getBreadcrumb() {
    const { city, country, frontend_tree } = this.breadcrumb

    let breadcrumb = [{
      deeplink: this.$href('/'),
      name: this.$t('global.text.index'),
      id: 0
    }]

    if (country) {
      breadcrumb = breadcrumb.concat({
        ...country,
        deeplink: this.$href(`/coureg/${country.id}-${country.seo}/`)
      })
    }

    if (city) {
      breadcrumb = breadcrumb.concat({
        ...city,
        deeplink: this.$href(`/city/${city.id}-${city.seo}/`)
      })
    }

    return breadcrumb.concat(frontend_tree)
  }
}
